import { FaArrowRight } from "react-icons/fa";
import ButtonPrimary from "../../components/button_primary";

export default function CallToAction2() {
  return (
    <section
      className="relative  bg-cover bg-center bg-fixed flex items-center"
      style={{ backgroundImage: "url('/img/landing/place.jpg')" }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="relative mx-auto max-w-screen-2xl px-6 lg:px-8 my-24 w-full">
        <div className="max-w-7xl">
          <h2 className="md:text-6xl text-3xl  font-extrabold uppercase leading-tight text-white">
            ¡Tu seguridad es nuestra prioridad!
          </h2>
          <div className="mt-4">
            <p className="text-lg  text-gray-200">
              En <strong>Border Protect Seguridad Privada</strong>, ofrecemos soluciones confiables y profesionales para 
              proteger tu patrimonio y tranquilidad. Nuestro equipo está listo para brindarte la mejor seguridad con un 
              servicio personalizado y eficiente.
            </p>
          </div>

          <div className="flex items-end">
            <ButtonPrimary href={"contacto"} text={"Contáctanos"} type={"primary"}/>
          </div>
        </div>
      </div>
    </section>
  );
}
